<template>
  <div>
    <div v-for="(item, tindex) in datalist" :key="tindex">
      <div
        v-if="isDisplayIntent(item)"
        :class="[
          {
            'flow-item-box-focus shadow': flowActiveIds.includes(
              item.mainIntentId
            ),
          },
        ]"
      >
        <div :class="['my-2 pointer flow-item-box']">
          <div class="p-2 flow-card">
            <FlowCardItem
              :data="item"
              :flowActiveIds="flowActiveIds"
              :languageActiveId="languageActiveId"
              :filter="filter"
              :level="level"
              v-on:updateIntent="updateIntent"
              v-on:onReloadFlowList="onReloadFlowList"
              v-on:getNextFlowLists="getNextFlowLists"
            />
          </div>

          <b-collapse
            :visible="flowActiveIds.includes(item.mainIntentId)"
            class="card-detail-box"
          >
            <FlowCardItemDetails
              :data="item"
              :showAllKeyword="showAllKeyword"
              :flowActiveIds="flowActiveIds"
              :level="level"
              :languageActiveId="languageActiveId"
              :channelList="channelList"
              v-on:updateIntent="updateIntent"
              v-on:onReloadFlowList="onReloadFlowList"
              v-on:setShowAllKeyword="setShowAllKeyword"
              v-on:openNextFlowListFromButton="openNextFlowListFromButton"
              v-on:createOrUpdateChildIntent="createOrUpdateChildIntent"
            />
          </b-collapse>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FlowCardItem from "@/views/pages/flow-builder/components/FlowCardItem";
import FlowCardItemDetails from "@/views/pages/flow-builder/components/FlowCardItemDetails";
export default {
  props: {
    datalist: {
      required: true,
      type: Array,
    },
    level: {
      required: true,
      type: Number,
    },
    flowActiveIds: {
      required: true,
      type: Array,
    },
    showAllKeyword: {
      required: true,
      type: Boolean,
    },
    channelList: {
      required: true,
      type: Array,
    },
    tierList: {
      required: true,
      type: Array,
    },
    languageActiveId: {
      required: true,
      type: Number,
    },
    filter: {
      required: false,
      type: Object,
    },
    filterIntent: {
      required: false,
      type: Object,
    },
  },
  components: {
    FlowCardItem,
    FlowCardItemDetails,
  },
  created: async function () {},
  methods: {
    checkFilter(item) {
      let isFoundedChannel = this.filter.channel.some((ai) =>
        item.channel.includes(ai)
      );
      let isFoundedTier = this.filter.tier.some((ai) => item.tier.includes(ai));
      return isFoundedChannel && isFoundedTier;
    },
    isDisplayIntent(item) {
      if (item.channel.length == 0) {
        return false;
      } else if (item.tier.length == 0) {
        return false;
      } else {
        let data = item.intent.find(
          (el) => el.language == this.languageActiveId
        );
        if (!data.name) {
          return false;
        } else if (data.keyword.length == 0 && item.intentTypeId == 1) {
          return false;
        }
      }
      return true;
    },
    getNextFlowLists(level, item) {
      this.$emit("getNextFlowLists", level, item);
    },
    openNextFlowListFromButton(level, id) {
      this.$emit("openNextFlowListFromButton", level, id);
    },
    setShowAllKeyword() {
      this.$emit("setShowAllKeyword");
    },
    onReloadFlowList() {
      this.$emit("onReloadFlowList");
    },
    createOrUpdateChildIntent(item, mainIntent) {
      this.$emit("createOrUpdateChildIntent", item, this.level, mainIntent);
    },
    updateIntent(item) {
      this.$emit("updateIntent", item, this.level);
    },
  },
};
</script>

<style lang="scss" scoped>
.flow-item-box {
  border: 2px solid #e5e2ee;
  border-radius: 6px;
}
.flow-item-box-focus {
  background-color: white;
  border-radius: 6px;
  border: 2px solid #7160c4;
}
.flow-item-search-focus-box {
  border: 2px solid #7160c4;
}
.flow-item-box-focus > .flow-item-box {
  border: 0;
}
.card-detail-box {
  border-radius: 2px;
}
.nodata-box {
  border: 2px solid #e5e2ee;
  border-radius: 6px;
}
.flow-card {
  min-height: 55px;
  display: flex;
  align-items: center;
}
</style>
